<template>
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <!-- <el-form-item label="回收员" prop="wlUserId">
          <el-select
            v-model="queryParam.wlUserId"
            clearable
            filterable
            remote
            :remote-method="recyclerRemoteMethod"
            :loading="recyclerLoading"
          >
            <el-option
              v-for="item in recyclerOpts"
              :key="item.wlUserId"
              :label="item.name"
              :value="item.wlUserId"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="code">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.traceabilityCode"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <div class="selectBox">
          <span class="selectText">类型</span>
          <el-select v-model="queryParam.type" size="mini" placeholder="请选择">
            <el-option label="请选择" value></el-option>
            <el-option label="可回收物" value="1"></el-option>
            <el-option label="商城订单" value="2"></el-option>
          </el-select>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #type="slotData">
        <p v-if="slotData.data.row.type == 1">可回收物</p>
        <p v-if="slotData.data.row.type == 2">商城订单</p>
      </template>
      <template #handlerSlot="slotData">
        <el-button
          size="mini"
          type="success"
          @click="handleDetail(slotData.data.row)"
          >详情</el-button
        >
      </template>
    </e-table>
    <modal-form ref="modalForm" @ok="modalFormOk"></modal-form>
  </div>
</template>

<script>
import { getRecyclertList } from "@/api/sign"
import modalForm from "./component/traceabilityModal";

import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
export default {
  components: { eTable, modalForm },
  mixins: [listMixin],
  props: {},
  data() {
    return {
      deleteKey: "userId",
      url: {
        list: "/traceabilityCode/queryPage",
      },

      //字段权限
      columns: [
        {
          field: "traceabilityCode",
          label: "code",
        },
        {
          field: "type",
          label: "类型",
          width: 100,
          slotName: "type",
          columnType: "slot",
        },
        {
          field: "createTime",
          label: "创建时间",
        },
        {
          width: 160,
          label: "编辑",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
      recyclerOpts: [],
      recyclerLoading: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    recyclerRemoteMethod (name) {
      if (name !== "") {
        this.recyclerLoading = true
        getRecyclertList({ name, pageNo: 1, pageSize: 999 }).then((res) => {
          this.recyclerOpts = res.data.records
          this.recyclerLoading = false
        })
      } else {
        this.recyclerOpts = []
        this.recyclerLoading = false
      }
    },
    fetchData() {
      console.log(this.ipagination.page);
    },
    add(val) {
      console.log(val);
    },
    edit(val) {},
    del(val) {},
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
